import { runtimeEnv } from "configuration"
import { joinUrl } from "utils/helpers"

export const sandboxClient = {
  sandboxNameExists: async ({ userName, sandboxName }: { userName: string, sandboxName: string }) => {
    return fetch(joinUrl(runtimeEnv.REACT_APP_SANDBOX_BACKEND_URL, "api/username", userName, "codeshare", sandboxName))
      .then((response) => {
        return response.status === 200
      })
  }
};